import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

type AdminInfoMessage = WebSocketMessageWithFields<'admin-info', {
  dataSets: unknown[];
  environment: string;
  adminReloadInProgress: boolean;
  adminReloadImagesInProgress: boolean;
  adminReloadQuantfuryInProgress: boolean;
  adminReloadCoingeckoInProgress: boolean;
  adminReloadCountriesInProgress: boolean;
  adminRebuildLocalesInProgress: boolean;
}>;

type AdminReloadImagesStartMessage = WebSocketMessageEmpty<'admin-reload-images-start'>;
type AdminReloadImagesFailMessage = WebSocketMessageEmpty<'admin-reload-images-fail'>;
type AdminReloadImagesFinishMessage = WebSocketMessageEmpty<'admin-reload-images-finish'>;
type AdminReloadQuantfuryStartMessage = WebSocketMessageEmpty<'admin-reload-quantfury-start'>;
type AdminReloadQuantfuryFailMessage = WebSocketMessageEmpty<'admin-reload-quantfury-fail'>;
type AdminReloadQuantfuryFinishMessage = WebSocketMessageEmpty<'admin-reload-quantfury-finish'>;
type AdminReloadCoingeckoStartMessage = WebSocketMessageEmpty<'admin-reload-coingecko-start'>;
type AdminReloadCoingeckoFailMessage = WebSocketMessageEmpty<'admin-reload-coingecko-fail'>;
type AdminReloadCoingeckoFinishMessage = WebSocketMessageEmpty<'admin-reload-coingecko-finish'>;
type AdminReloadCountriesStartMessage = WebSocketMessageEmpty<'admin-reload-countries-start'>;
type AdminReloadCountriesFailMessage = WebSocketMessageEmpty<'admin-reload-countries-fail'>;
type AdminReloadCountriesFinishMessage = WebSocketMessageEmpty<'admin-reload-countries-finish'>;
type AdminRebuildLocalesStartMessage = WebSocketMessageEmpty<'admin-rebuild-locales-start'>;
type AdminRebuildLocalesFailMessage = WebSocketMessageEmpty<'admin-rebuild-locales-fail'>;
type AdminRebuildLocalesFinishMessage = WebSocketMessageEmpty<'admin-rebuild-locales-finish'>;

// Объединенный тип для всех сообщений
type AdminWebSocketMessage = 
  | AdminInfoMessage 
  | AdminReloadImagesStartMessage 
  | AdminReloadImagesFailMessage 
  | AdminReloadImagesFinishMessage 
  | AdminReloadQuantfuryStartMessage 
  | AdminReloadQuantfuryFailMessage 
  | AdminReloadQuantfuryFinishMessage 
  | AdminReloadCoingeckoStartMessage 
  | AdminReloadCoingeckoFailMessage 
  | AdminReloadCoingeckoFinishMessage 
  | AdminReloadCountriesStartMessage 
  | AdminReloadCountriesFailMessage 
  | AdminReloadCountriesFinishMessage 
  | AdminRebuildLocalesStartMessage 
  | AdminRebuildLocalesFailMessage 
  | AdminRebuildLocalesFinishMessage;

// WebSocket message handler

export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'dataAdmin',
},
  __name: 'admin',
  setup(__props) {

const store = useStore<RootState>();



// Типы для WebSocket сообщений компонента admin
const handleWebSocketMessage = (data: AdminWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'admin-info':
      store.dispatch('admin/wsAdminInfo', {
        dataSets: data.dataSets,
        environment: data.environment,
        adminReloadInProgress: data.adminReloadInProgress,
        adminReloadImagesInProgress: data.adminReloadImagesInProgress,
        adminReloadQuantfuryInProgress: data.adminReloadQuantfuryInProgress,
        adminReloadCoingeckoInProgress: data.adminReloadCoingeckoInProgress,
        adminReloadCountriesInProgress: data.adminReloadCountriesInProgress,
        adminRebuildLocalesInProgress: data.adminRebuildLocalesInProgress,
      });
      break;
    case 'admin-reload-images-start':
      store.dispatch('admin/wsAdminReloadImagesStart');
      break;
    case 'admin-reload-images-fail':
      store.dispatch('admin/wsAdminReloadImagesFinish');
      break;
    case 'admin-reload-images-finish':
      store.dispatch('admin/wsAdminReloadImagesFinish');
      break;
    case 'admin-reload-quantfury-start':
      store.dispatch('admin/wsAdminReloadQuantfuryStart');
      break;
    case 'admin-reload-quantfury-fail':
      store.dispatch('admin/wsAdminReloadQuantfuryFinish');
      break;
    case 'admin-reload-quantfury-finish':
      store.dispatch('admin/wsAdminReloadQuantfuryFinish');
      break;
    case 'admin-reload-coingecko-start':
      store.dispatch('admin/wsAdminReloadCoingeckoStart');
      break;
    case 'admin-reload-coingecko-fail':
      store.dispatch('admin/wsAdminReloadCoingeckoFinish');
      break;
    case 'admin-reload-coingecko-finish':
      store.dispatch('admin/wsAdminReloadCoingeckoFinish');
      break;
    case 'admin-reload-countries-start':
      store.dispatch('admin/wsAdminReloadCountriesStart');
      break;
    case 'admin-reload-countries-fail':
      store.dispatch('admin/wsAdminReloadCountriesFinish');
      break;
    case 'admin-reload-countries-finish':
      store.dispatch('admin/wsAdminReloadCountriesFinish');
      break;
    case 'admin-rebuild-locales-start':
      store.dispatch('admin/wsAdminRebuildLocalesStart');
      break;
    case 'admin-rebuild-locales-fail':
      store.dispatch('admin/wsAdminRebuildLocalesFinish');
      break;
    case 'admin-rebuild-locales-finish':
      store.dispatch('admin/wsAdminRebuildLocalesFinish');
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})